/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Branding } from '@core/models';
import { createAction, props } from '@ngrx/store';

export const loadBranding = createAction('[ClientDetails:Branding] Load Branding');
export const loadBrandingSuccess = createAction(
  '[ClientDetails:Branding] Load Branding Success',
  props<{ branding: Branding | null }>()
);
export const loadBrandingFailure = createAction(
  '[ClientDetails:Branding] Load Branding Failure',
  props<{ errorMessage: string }>()
);
export const setBranding = createAction('[ClientDetails:Dashboard] Set Branding', props<{ branding: Branding }>());
export const createUpdateBranding = createAction(
  '[ClientDetails:Branding] Create/Update Branding',
  props<{ branding: Branding | null }>()
);
export const createUpdateBrandingSuccess = createAction(
  '[ClientDetails:Branding] Create/Update Branding Success',
  props<{ branding: Branding }>()
);
export const createUpdateBrandingFailure = createAction(
  '[ClientDetails:Branding] Create/Update Branding Failure',
  props<{ errorMessage: string }>()
);
export const updateCompanyLogo = createAction(
  '[ClientDetails:Company Profile] Update Branding Company Logo',
  props<{ branding: Branding }>()
);
export const updateCompanyLogoSuccess = createAction(
  '[ClientDetails:Company Profile] Update Branding Company Logo Success',
  props<{ branding: Branding }>()
);
export const updateCompanyLogoFailure = createAction(
  '[ClientDetails:Company Profile] Update Branding Company Logo Failure',
  props<{ errorMessage: string }>()
);
